export const BENEFITS = ['Regina Maria plan', 'Meal tickets', '7card', 'Bookster', 'Audiobook'];
